export default ({ primary, navbarBackground }) => ({
  '.button:not(.is-outlined)': {
    '&.is-primary': {
      backgroundColor: `${primary} !important`,
    },
    '&.is-primary:hover': {
      backgroundColor: `${primary} !important`,
    },
  },
  '.button.is-outlined': {
    borderColor: `${primary} !important`,
    color: `${primary} !important`,
    '&:hover': {
      backgroundColor: `${primary} !important`,
      color: `${navbarBackground} !important`,
    },
  },
});
